import Paper from '@material-ui/core/Paper';
import React, { Component } from 'react';

import { EditCommandCell } from '../../../common/tableEditCommandCell';
import { getAuthToken } from '../../../utilities/authUtils';
import { BASE_URL as INTAKE_V2_BASE_URL } from '../../../middleware/intakeV2Api';
import TableCell from '@material-ui/core/TableCell';

import {
  Getter,
} from '@devexpress/dx-react-core';

import {
  DataTypeProvider,
  EditingState,
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableEditColumn,
  TableFilterRow,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';

import { dateFormatter } from '../../../utilities/dateFormatter';

const DateTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={dateFormatter}
    {...props}
  />
);

class DocumentsGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'addedBy', title: 'Added By' },
        { name: 'uploadedOn', title: 'Added On' },
        { name: 'fileName', title: 'Document' },
      ],
      rows: [],
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15],
      dateColumns: ['uploadedOn'],
      sorting: [{ columnName: 'uploadedOn', direction: 'desc' }],
      filters: [],
    };

    this.changeSorting = (sorting) => this.setState({ sorting });

    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });

    this.changeFilters = (filters) => this.setState({ filters });

    this.commitChanges = this.commitChanges.bind(this);
    this.downloadFile = this.downloadFile.bind(this);

    this.TableRow = ({ row, handleViewSubmittedAuth, ...restProps }) => {
      return (<Table.Row
        {...restProps}
        style={{
          cursor: 'default',
        }}
              />);
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ rows: nextProps.rows || [] });
  }

  componentWillMount() {
    this.setState({ rows: this.props.rows || [] });
  }

  getAttachmentId(value) {
    if (!value) {
      return null;
    }

    return (
      value.attachmentId ??
      value.AttachmentId ??
      value.fileId ??
      value.FileId ??
      value.id ??
      value.Id ??
      null
    );
  }

  getDownloadFileName(response, rowData) {
    const contentDisposition = response.headers.get('content-disposition') || '';
    const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8FileNameMatch && utf8FileNameMatch[1]) {
      return decodeURIComponent(utf8FileNameMatch[1]);
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (fileNameMatch && fileNameMatch[1]) {
      return fileNameMatch[1];
    }

    return rowData?.fileName || rowData?.FileName || 'document';
  }

  async downloadFile(row){
    try {
      const rowData = row?.row || row || {};
      const attachmentId = this.getAttachmentId(rowData);
      if (!attachmentId) {
        return;
      }

      const token = getAuthToken();
      const response = await fetch(`${INTAKE_V2_BASE_URL}api/authorizationFile/${encodeURIComponent(attachmentId)}/download`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const contentType = response.headers.get('content-type') || '';
      if (contentType.toLowerCase().includes('application/json')) {
        const errorText = await response.text();
        throw new Error(`Download returned JSON payload: ${errorText}`);
      }

      const fileBlob = await response.blob();
      const objectUrl = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = this.getDownloadFileName(response, rowData);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Document download failed:', error);
    }
  }

  actionsCell = (props) => {
    return (
      <TableCell>
        <EditCommandCell
          id="attachment"
          text=""
          icon="paperclip"
          onExecute={this.downloadFile}
          tableRow={props.tableRow}
        >{React.Children.toArray(props.children)}
        </EditCommandCell>
      </TableCell>
    );
  }

  commitChanges() {

  }

  render() {
    const { rows, columns, pageSize, pageSizes, currentPage, dateColumns, filters, sorting } = this.state;

    const safeRows = Array.isArray(rows) ? rows : [];
    const safeColumns = Array.isArray(columns) ? columns : [];
    const safeDateColumns = Array.isArray(dateColumns) ? dateColumns : [];
    const safeSorting = Array.isArray(sorting) ? sorting : [];
    const safeFilters = Array.isArray(filters) ? filters : [];
    const safePageSizes = Array.isArray(pageSizes) ? pageSizes : [];

    return (
      <Paper style={{ padding: '1rem' }}>
        <div style={{ padding: '1rem', fontSize: '1.5rem', width: '50%' }}>Documents</div>
        <Grid
          rows={safeRows}
          columns={safeColumns}
        >
          <DateTypeProvider
            for={safeDateColumns}
          />
          <EditingState
            onEditingRowIdsChange={this.changeEditingRowIds}
            onCommitChanges={this.commitChanges}
          />
          <SortingState
            sorting={safeSorting}
            onSortingChange={this.changeSorting}
          />
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={this.changeCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={this.changePageSize}
          />
          <IntegratedSorting />
          <FilteringState
            filters={safeFilters}
            onFiltersChange={this.changeFilters}
          />
          <IntegratedFiltering />
          <IntegratedPaging />
          <Table rowComponent={this.TableRow} />
          {/* <TableColumnResizing
            columnWidths={columnWidths}
            onColumnWidthsChange={this.changeColumnWidths}
          /> */}
          <TableHeaderRow showSortingControls />
          <TableEditColumn
            style={{ marginRight: '2rem' }}
            cellComponent={this.actionsCell}
          />
          <TableFilterRow />
          <Getter
            name="tableColumns"
            computed={({ tableColumns }) => {
              const safeTableColumns = tableColumns || [];
              return [
                ...safeTableColumns.filter((c) => c.type !== TableEditColumn.COLUMN_TYPE),
                { key: 'editCommand', type: TableEditColumn.COLUMN_TYPE, width: 150 },
              ];
            }}
          />
          <PagingPanel
            pageSizes={safePageSizes}
          />
        </Grid>
      </Paper>
    );
  }
}

export default DocumentsGrid;